const initialState = () => {
  return {
      /**
       * @description
       * Contains properties to format the modal snackbar
       * and data that it shows to the user about an
       * event they unleash.
       */
    employee: {},
  }
}

export default initialState
